import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Inbox, GitBranch, Brain, BarChart3, FileText, Megaphone, Building2 } from 'lucide-react';
import { cn } from '../../utils/cn';
interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
interface NavGroup {
  label: string;
  accent: string;
  activeClass: string;
  items: NavItem[];
}
const groups: NavGroup[] = [{
  label: 'Pipeline',
  accent: 'bg-uae-green',
  activeClass: 'bg-uae-green text-white',
  items: [{
    to: '/',
    label: 'Command dashboard',
    icon: LayoutDashboard
  }, {
    to: '/applications',
    label: 'Applications queue',
    icon: Inbox
  }]
}, {
  label: 'Lifecycle',
  accent: 'bg-uae-leaf',
  activeClass: 'bg-uae-leaf text-white',
  items: [{
    to: '/lifecycle',
    label: 'Portfolio board',
    icon: GitBranch
  }]
}, {
  label: 'Intelligence',
  accent: 'bg-uae-navy',
  activeClass: 'bg-uae-navy text-white',
  items: [{
    to: '/intelligence',
    label: 'AI intelligence hub',
    icon: Brain
  }, {
    to: '/analytics',
    label: 'AI analytics',
    icon: BarChart3
  }, {
    to: '/reports',
    label: 'Reports archive',
    icon: FileText
  }]
}, {
  label: 'Delivery',
  accent: 'bg-uae-gold',
  activeClass: 'bg-uae-bronze text-white',
  items: [{
    to: '/outreach',
    label: 'Outreach & amplification',
    icon: Megaphone
  }]
}, {
  label: 'Administration',
  accent: 'bg-uae-ink',
  activeClass: 'bg-uae-ink text-white',
  items: [{
    to: '/registry',
    label: 'Entities registry',
    icon: Building2
  }]
}];
export function SideNav() {
  return <nav aria-label="Platform sections" className="hidden w-60 shrink-0 border-r border-border bg-sidebar px-3 py-4 lg:block" data-id="element-742" data-mp="snhp54u8ujve">
      <div className="space-y-5" data-id="element-743" data-mp="1l53ggykg2npf">
        {groups.map(group => <div key={group.label} data-id="element-744" data-mp="1l7g70049q6e3">
            <p className="flex items-center gap-1.5 px-2 pb-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-muted-foreground" data-id="element-745" data-mp="1gevdkzp9xvb3">
              <span className={cn('h-2 w-2 rounded-sm', group.accent)} aria-hidden="true" data-id="element-746" data-mp="3amzb212aqekq" />
              {group.label}
            </p>
            <ul className="space-y-0.5" data-id="element-747" data-mp="3fneostqhpo38">
              {group.items.map(item => <li key={item.to} data-id="element-748" data-mp="30ul5ex83knta">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => cn('flex items-center gap-2.5 rounded-sm px-2 py-2 text-[13px] transition-colors', isActive ? group.activeClass : 'text-foreground hover:bg-muted')} data-id="element-749" data-mp="35v8u3c8usskc">
                    <item.icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-750" data-mp="2mxeq5cml178t" />
                    <span className="truncate" data-id="element-751" data-mp="g7hyiky75jjc">{item.label}</span>
                  </NavLink>
                </li>)}
            </ul>
          </div>)}
      </div>

      <div className="mt-8 rounded-sm border border-border bg-muted/60 p-3" data-id="element-752" data-mp="25n12yn04ztqi">
        <p className="text-[11px] font-medium text-foreground" data-id="element-753" data-mp="20ohfuj9t4bwk">Prototype environment</p>
        <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground" data-id="element-754" data-mp="20mmqmsri5xmo">
          Records are seeded demonstration data. AI runs are simulated and every decision is
          recorded on the audit timeline.
        </p>
      </div>
    </nav>;
}